import { getApiUrl } from "Services/ProxyConfig";

export const CSRF_TOKEN_HEADER = "X-CSRF-Token";

type CsrfTokenResponse = {
    csrfToken: string;
};

function getAuthUrl(path: string): string {
    return `${getApiUrl()}/auth${path}`;
}

let csrfToken: string | null = null;

export async function loadCsrfToken(): Promise<void> {
    const response = await fetch(getAuthUrl("/csrf-token"), {
        credentials: "include",
    });

    if (!response.ok) {
        throw new Error("Failed to load csrf token");
    }

    const data: CsrfTokenResponse = await response.json();
    ({ csrfToken } = data);
}

export function getCsrfToken(): string {
    return csrfToken || "";
}
